import { Apollo } from 'apollo-angular'
import { ApolloQueryResult } from '@apollo/client/core'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { NotFoundError } from 'src/app/core/errors/errors'
import { defaultSurveyReportType } from 'common/reportTypes'
import { NavService } from 'src/app/core/nav.service'
import { safeGet } from '../../util/util'
import { PageHeaderAction } from '../page-header/page-header.component'
import deleteMutation from './delete-survey-tests-details.gql'
import query from './survey-tests-details.gql'
import { delete_survey_test_by_pk } from './types/delete_survey_test_by_pk'
import { surveyTestsDetails } from './types/surveyTestsDetails'
import { reportHandled } from 'src/app/core/errors/issueTracker'

@Component({
  selector: 'app-survey-tests-details',
  templateUrl: './survey-tests-details.component.html',
  styleUrls: ['./survey-tests-details.component.scss'],
})
export class SurveyTestsDetailsComponent implements OnInit {
  @Input() survey_testId: number

  loading = false

  editing = false

  queryResult: ApolloQueryResult<surveyTestsDetails>

  safeGet = safeGet

  @Output() updateEvent = new EventEmitter()

  actions: PageHeaderAction[] = [
    { text: 'Delete Form', class: 'danger' },
    { text: 'Edit Form' },
    { text: 'Generate Report' },
  ]

  title = 'Form Details'

  constructor(
    private apollo: Apollo,
    private route: ActivatedRoute,
    private nav: NavService,
  ) {}

  actionsHandler($event: string) {
    switch ($event) {
      case 'Delete Form':
        this.delete()
        break
      case 'Edit Form':
        this.editView()
        break
      case 'Generate Report':
        this.generateReport()
        break
      default:
        break
    }
  }

  ngOnInit() {
    if (!this.survey_testId) {
      this.survey_testId = this.route.snapshot.params.id
    }
    this.fetchsurveyTestsDetails()
  }

  fetchsurveyTestsDetails = () => {
    this.loading = true
    this.apollo
      .query<surveyTestsDetails>({
        query,
        variables: { id: this.survey_testId },
      })
      .subscribe({ next: this.onNext, error: this.onError })
  }

  onNext = (result: ApolloQueryResult<surveyTestsDetails>) => {
    this.loading = false
    this.queryResult = result
    if (result.errors) {
      throw result.errors[0]
    }
    if (!this.survey_test) {
      throw new NotFoundError('form', this.survey_testId, [
        'home',
        'surveyTests',
      ])
    }
  }

  onError = (err: unknown) => {
    this.loading = false
    throw err
  }

  get survey_test() {
    return this.queryResult?.data?.survey_test_by_pk
  }

  get scanner() {
    return this.survey_test.scanner
  }

  get facility() {
    return this.scanner.facility
  }

  get room() {
    return this.scanner.facility_room
  }

  get scannerName() {
    return this.survey_test.scanner.name
  }

  get facilityName() {
    return this.scanner.facility?.name
  }

  get roomName() {
    return this.scanner.facility_room.name
  }

  delete() {
    if (window.confirm('Delete Form: are you sure?')) {
      this.apollo
        .mutate<delete_survey_test_by_pk>({
          mutation: deleteMutation,
          variables: { id: this.survey_testId },
        })
        .subscribe({
          next: (result) => {
            if (result.errors) {
              throw result.errors[0]
            }
            this.nav.navtree.surveyTests()
          },
          error: (err) => {
            console.log(err)
            reportHandled(err, 'delete a form')
          },
        })
    }
  }

  editView() {
    this.editing = true
  }

  onSave($event) {
    this.editing = false
    this.updateEvent.emit($event)
    this.fetchsurveyTestsDetails()
  }

  get scannerId() {
    return this.survey_test.scannerId
  }

  /**
   * Open the Reports page's generate form with this survey's device, the
   * modality's survey-driven monthly report and the survey's month selected.
   */
  generateReport() {
    this.nav.navtree.generateReport({
      scannerId: this.scannerId,
      reportType: defaultSurveyReportType(this.scanner.modality?.id),
      periodEnd: this.survey_test.dateCreated,
    })
  }
}
